export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=709b0541a8296735b607912758645d5d8bbf2e81b2&name=pushAdClickData!'